var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { key: `list-item-${_vm.index}` },
    [
      _c(
        "jade-list-item",
        {
          attrs: {
            navigation: "",
            label: _vm.$t(_vm.source?.type),
            description: _vm._f("dateFormat")(
              _vm.source?.created_at,
              _vm.crateAtFormat
            ),
            "third-line": _vm.source?.observation,
          },
          on: {
            onClick: function ($event) {
              return _vm.handleClick(_vm.source?.id, "serviceOrdersDetail")
            },
          },
        },
        [
          _c("template", { slot: "trailing" }, [
            _c(
              "div",
              { staticClass: "flex flex-col items-end" },
              [
                _c("jade-text", { attrs: { color: "medium" } }, [
                  _vm._v(" " + _vm._s(_vm.source?.id) + " "),
                ]),
                _c(
                  "div",
                  { staticClass: "mt-1" },
                  [
                    _c(
                      "jade-tag",
                      {
                        attrs: {
                          size: "medium",
                          variant: _vm.statusTag(
                            _vm.source?.status_description
                          ),
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.source?.status_description) + " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      !_vm.hasLastItem
        ? _c("div", { staticClass: "px-5" }, [_c("jade-divider")], 1)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }